// Exemplo animado do passo a passo, só em chat novo (porte do Portal da Cidade). Toca uma vez e
// termina convidando a digitar. Coordenadas da tela-exemplo (300×200), iguais às do portal.
import { useEffect, useState } from "react";
import { ArrowDown } from "./icones";
import css from "./SuporteIA.module.css";
const PERG = "Onde gero minha lista?";
const FIM = 9.2; // segundos
const INICIO_BALAO = [206, 186];
const PASSOS = [
  { a: { x: 8, y: 28, w: 48, h: 8 }, b: [72, 18], t: "Abra o menu da esquerda" },
  { a: { x: 232, y: 8, w: 56, h: 16 }, b: [134, 30], t: "Clique no botão do topo" },
  { a: { x: 74, y: 104, w: 218, h: 44 }, b: [100, 154], t: "Veja a lista aqui" },
];
const ITENS = [12, 28, 44, 60, 76];
const CARDS = [
  [74, 32, 100, 62],
  [182, 32, 110, 62],
  [74, 104, 218, 44],
  [74, 156, 218, 38],
];
const cl = (v) => Math.min(1, Math.max(0, v));
const ease = (p) => (p < 0.5 ? 2 * p * p : 1 - (-2 * p + 2) ** 2 / 2);
const seg = (t, a, b) => ease(cl((t - a) / (b - a)));
const lerp = (a, b, p) => a + (b - a) * p;
export default function ExemploDoGuia({ sumir }) {
  const [t, setT] = useState(0);
  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      const id = setTimeout(() => setT(FIM), 0);
      return () => clearTimeout(id);
    }
    let raf = 0;
    const t0 = performance.now();
    const passo = (agora) => {
      const s = (agora - t0) / 1000;
      setT(Math.min(s, FIM));
      if (s < FIM) raf = requestAnimationFrame(passo);
    };
    raf = requestAnimationFrame(passo);
    return () => cancelAnimationFrame(raf);
  }, []);
  const i = t < 4.1 ? 0 : t < 5.6 ? 1 : 2;
  const base = 2.6 + 1.5 * i;
  const passoAtual = PASSOS[i];
  const [fx, fy] = passoAtual.b;
  let bx, by;
  if (t < 2.6) {
    const p = seg(t, 1.7, 2.4);
    bx = lerp(INICIO_BALAO[0], fx, p);
    by = lerp(INICIO_BALAO[1], fy, p);
  } else {
    const p = i > 0 ? seg(t, base - 0.4, base) : 1;
    const [px, py] = PASSOS[Math.max(0, i - 1)].b;
    bx = lerp(px, fx, p);
    by = lerp(py, fy, p);
  }
  const a = passoAtual.a;
  const ox = bx + (a.x < bx ? 0 : 90),
    oy = by + 14,
    tx = a.x + a.w / 2,
    ty = a.y + a.h / 2;
  const linha = seg(t, base, base + 0.45);
  const realce = seg(t, base + 0.4, base + 0.6);
  const branco = seg(t, 7, 7.6);
  const convite = seg(t, 7.4, 7.8);
  const desce = seg(t, 8, 9);
  return (
    <div aria-hidden="true" data-exemplo-guia className={css.exemplo} style={{ opacity: sumir ? 0 : 1 }}>
      <div className={css.exemploPalco} style={{ opacity: seg(t, 0, 0.4) }}>
        <span className={css.exemploSelo}>exemplo</span>
        <p className={css.exemploPergunta} style={{ visibility: t < 0.4 ? "hidden" : "visible" }}>
          {PERG.slice(0, Math.round(PERG.length * seg(t, 0.4, 1.4))) || " "}
        </p>
        <div className={css.exemploTela}>
          <div className={css.exemploMenu} />
          {ITENS.map((y) => (
            <div key={y} className={css.exemploItem} style={{ top: y }} />
          ))}
          <div className={css.exemploBotao} style={{ left: 232, top: 8, width: 56, height: 16 }} />
          {CARDS.map(([x, y, w, h]) => (
            <div key={y * 1000 + x} className={css.exemploCard} style={{ left: x, top: y, width: w, height: h }} />
          ))}
          <div className={css.exemploVeu} style={{ opacity: seg(t, 2.4, 2.8) }} />
          {[0, 1].map((k) => (
            <div
              key={k}
              className={css.exemploRealce}
              style={{
                left: a.x - 4,
                top: a.y - 4,
                width: a.w + 8,
                height: a.h + 8,
                opacity: realce,
                ...(k
                  ? { border: "1.5px solid #8b5cf6" }
                  : { background: "rgba(255,255,255,.6)", boxShadow: "0 0 22px 14px rgba(255,255,255,.95)" }),
              }}
            />
          ))}
          <svg className={css.exemploSvg} width="300" height="200">
            <path
              d={`M${ox},${oy} Q${(ox + tx) / 2},${Math.min(oy, ty) - 30} ${tx},${ty}`}
              pathLength={1}
              fill="none"
              stroke="#8b5cf6"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeOpacity=".8"
              strokeDasharray="1"
              strokeDashoffset={1 - linha}
              style={{ opacity: 1 - seg(t, base + 0.9, base + 1.1) }}
            />
          </svg>
          <div
            className={css.exemploBalao}
            style={{
              left: bx,
              top: by,
              opacity: seg(t, 1.7, 2),
              transform: `scale(${lerp(0.6, 1, seg(t, 1.7, 2.4))})`,
            }}
          >
            <b className={css.exemploBalaoPasso}>PASSO {i + 1} DE 3</b>
            {passoAtual.t}
            <i className={css.exemploLinha} />
            <i className={css.exemploLinhaCurta} />
          </div>
        </div>
      </div>
      <div className={css.exemploFade} style={{ opacity: branco }} />
      <p
        className={css.exemploConvite}
        style={{ opacity: convite, top: `calc(40% * ${1 - desce} + (100% - 52px) * ${desce})` }}
      >
        Pronto para começar? Digite aqui
        <ArrowDown size={18} className={css.quica} />
      </p>
    </div>
  );
}
